module.exports = __webpack_public_path__ + "assets/img/logo.fc8dc040.svg";